import PropTypes from 'prop-types';

import css from './index.module.scss';

const Mission = ({ copy, title }) => (
  <div className={css.root}>
    <div className={css.title}>
      {title.split('\n').map((titl) => (
        <div dangerouslySetInnerHTML={{ __html: titl }} key={titl} />
      ))}
      <div className={css.copy} dangerouslySetInnerHTML={{ __html: copy }} />
    </div>
  </div>
);
Mission.propTypes = {
  copy: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
export default Mission;
